<template>
	<div class="newReview">
		<el-dialog
			:visible.sync="dialogVisible" :before-close="handleCloseNewReview" :close-on-click-modal="false" :append-to-body="false">
			<p class="title pl14">
				<i class="iconfont icon-xinjian mr8"></i>
				新审查原文文件上传
			</p>
			<div class="content contentUploadAgain">
				<!-- 重新上传 -->
				<el-tabs v-model="activeName" @tab-click="handleClick" v-if="data=='uploadAgain'">
					<!-- <el-tab-pane label="整篇审查" name="file" v-loading="loadingFile"> -->
					<el-tab-pane name="file" v-loading="loadingFile" v-if="reviewType=='file'">
						<el-form class="reviewForm" ref="ruleFormFile" :model="ruleFormFile">
							<el-form-item label="待审文件上传" class="proGuide" prop="proGuide" key="uploadAgain">
								<el-input v-model="ruleFormFile.proGuide" readonly="readonly"></el-input>
								<a @click="uploadFileFun" class="uploadFile fl el-icon-folder-opened" title="上传文件"></a>
								<input type="file" @change="uploadFile" ref="file" style="display:none;" />
							</el-form-item>
							<a class="startReview wid100 hlh56 tac bdr3" @click="wholeReviewFun">开始审查</a>
							<div class="tips pt15 pb19 tac lh24 mt16">
								<p>
									<i class="iconfont icon-ziyuan mr8 fwb"></i>
									注意：上传需对比的法规、格式为<span> DOC，DOCX，TXT </span>或<span> PDF </span></p>
								<p>请确认上传文件必须包含"文件标题"</p>
							</div>
						</el-form>
					</el-tab-pane>
					<!-- <el-tab-pane label="条目审查" name="item" v-loading="loadingItem">-->
					<el-tab-pane  name="item" v-loading="loadingItem" v-if="reviewType=='item'">
						<div class="reviewItem mb15">
							<p class="title pl19">待审条目内容</p>
							<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入条目内容" v-model.trim="itemCon"></el-input>
						</div>	
						<a class="startReview wid100 hlh56 tac bdr3" @click="itemReviewFun">开始审查</a>
					</el-tab-pane>
				</el-tabs>
				<!-- 新一轮的审查 -->
				<el-tabs v-model="activeName" @tab-click="handleClick" v-if="data=='newRoundReview'">
					<!-- <el-tab-pane label="整篇审查" name="file" v-loading="loadingFile"> -->
					<el-tab-pane name="file" v-loading="loadingFile" v-if="reviewType=='file'">
						<el-form class="reviewForm" ref="ruleFormFile" :model="ruleFormFile" key="newRoundReview">
							<el-form-item label="待审文件上传" class="proGuide">
								<el-input v-model="ruleFormFile.proGuide" readonly="readonly"></el-input>
								<a @click="uploadFileFun" class="uploadFile fl el-icon-folder-opened" title="上传文件"></a>
								<input type="file" @change="uploadFile" ref="file" style="display:none;" />
							</el-form-item>
							<a class="startReview wid100 hlh56 tac bdr3" @click="wholeReviewFunNoRequired">开始审查</a>
							<div class="tips pt15 pb19 tac lh24 mt16">
								<p>
									<i class="iconfont icon-ziyuan mr8 fwb"></i>
									注意：上传需对比的法规、格式为<span> DOC，DOCX，TXT </span>或<span> PDF </span></p>
								<p>请确认上传文件必须包含"文件标题"</p>
							</div>
						</el-form>
					</el-tab-pane>
					<!-- <el-tab-pane label="条目审查" name="item" v-loading="loadingItem">-->
					<el-tab-pane  name="item" v-loading="loadingItem" v-if="reviewType=='item'">
						<div class="reviewItem mb15">
							<p class="title pl19">待审条目内容</p>
							<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入条目内容" v-model.trim="itemCon"></el-input>
						</div>	
						<a class="startReview wid100 hlh56 tac bdr3" @click="itemReviewFunnNoRequired">开始审查</a>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props:['data'],
	data() {
		return {
			dialogVisible: false,//弹窗是否显示
			activeName: 'file',//当前显示的标签页 file整篇审查 item条目审查
			fileData: null, //获取的上传的文件对象
			ruleFormFile: { //整篇审查
				proGuide: "" //获取的上传的文件名
			},
			loadingFile:false,//整篇审查加载中
			itemCon:"",//条目内容
			loadingItem:false,//条目审查加载中

			uuid:"",//开始审查之后返回的uuid
			reviewType:"",//审查类型 item条目审查 file 整篇审查
		};
	},
	created(){
		this.reviewType=window.localStorage.getItem('reviewType');//获取审查类型
		this.activeName=this.reviewType;//当前标签		
	},
	methods:{
		//弹窗显示
		childFun(){
			this.dialogVisible = true; 
		},
		//弹窗关闭按钮
		handleCloseNewReview(){
			this.ruleFormFile.proGuide = "";
			this.fileData = null;
			this.activeName="file";
			this.dialogVisible = false; 
		},

		//tabs切换
		handleClick(tab, event) {
      //   console.log(tab, event);
      },
		//上传文档-获取上传的名称
		uploadFile(ev) {
			var objFile = ev.target.files[0];
			console.log(objFile);
			this.ruleFormFile.proGuide = objFile.name;

			if (
				this.ruleFormFile.proGuide.substring(
					this.ruleFormFile.proGuide.length - 3
				) == "doc"||this.ruleFormFile.proGuide.substring(
					this.ruleFormFile.proGuide.length - 4
				) == "docx"||this.ruleFormFile.proGuide.substring(
					this.ruleFormFile.proGuide.length - 3
				) == "txt"||this.ruleFormFile.proGuide.substring(
					this.ruleFormFile.proGuide.length - 3
				) == "pdf"
			) {
				//上传之后直接提交
				this.fileData = objFile;
				//解决文件名无法重复上传的问题
				this.$refs.file.value = null;
			} else {
				this.$message({
					message: "上传文件格式不对，请重新上传！", //请上传doc、docx、txt、或者pdf文档！
					type: "warning",
					duration: 3000
				});
				this.ruleFormFile.proGuide = "";
				this.fileData = null;
			}
		},
		//通过点击上传文档触发type="file"的功能
		uploadFileFun() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},
		//整篇审查
		wholeReviewFun(){
			// let data=await this.deleteReviewFun();
			if(this.fileData){
				//遮罩显示
				this.loadingFile=true;
				// let title=this.ruleFormFile.proGuide.split('.')[0];
				let title=this.ruleFormFile.proGuide.substring(0,this.ruleFormFile.proGuide.lastIndexOf('.'));
				// console.log('title',title);
				let formData = new FormData();
				formData.append("title", title); //文件名
				formData.append("checked_file", this.fileData); //文件
				formData.append("type", this.activeName); //类型

				this.axios({
					method: "post",
					url: "/japi/analysis/handle/",
					data: formData
				}).then(res => {
					if (res.data.code == 200) {
						console.log("整篇审查审查成功======");
						console.log(res);
						//遮罩隐藏
						this.loadingFile=false;
						this.$message({
							message: "整篇审查成功",
							type: "success",
							duration: 3000
						});
						//上传成功返回uuid
						this.uuid = res.data.data[0].file_uuid;	
						//解决文件名无法重复上传的问题
						this.$refs.file.value = null;
						//上传成功返回uuid
						window.localStorage.setItem('uuid',res.data.data[0].file_uuid);
						window.localStorage.setItem("reviewType",this.activeName);
						this.handleCloseNewReview();	
						this.$emit('uploadAgainFunParent');//触发父组件的初始

					} else if(res.data.code == 500){
						this.$message({
							message: "整篇审查失败，请重新上传！",
							type: "warning",
							duration: 3000
						});
					}
					else{
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					}
				});
			}else{
				this.$message({
					message: "请上传文件后进行审查！",
					type: "warning",
					duration: 3000
				});
			}
		},
		//条目审查
		itemReviewFun(){
		// async itemReviewFun(){
			// let data=await this.deleteReviewFun();
			if(this.itemCon){
				//遮罩显示
				console.log(this.itemCon.substr(0,20));
				this.loadingItem=true;
				let formData = new FormData();
				formData.append("title", this.itemCon.substr(0,20)); //文件名
				formData.append("checked_item", this.itemCon); //条目
				formData.append("type", this.activeName); //类型

				this.axios({
					method: "post",
					url: "/japi/analysis/handle/",
					data: formData
				}).then(res => {
					if (res.data.code == 200) {
						console.log("条目审查成功======");
						console.log(res);
						//遮罩隐藏
						this.loadingItem=false;
						this.$message({
							message: "条目审查成功",
							type: "success",
							duration: 3000
						});
						//上传成功返回uuid
						window.localStorage.setItem('uuid',res.data.data[0].file_uuid);
						window.localStorage.setItem("reviewType",this.activeName);
						this.handleCloseNewReview();
						this.$emit('uploadAgainFunParent');//触发父组件的初始
					} else if(res.data.code == 500){
						this.$message({
							message: "条目审查失败，请重新上传！",
							type: "warning",
							duration: 3000
						});
					}
					else{
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					}
				});
			}else{
				this.$message({
					message: "请输入条目内容后进行审查！", 
					type: "warning",
					duration: 3000
				});
			}
		},
		//先删除再重新上传解析
		deleteReviewFun(){
			let uuid=window.localStorage.getItem('uuid');
			let p=new Promise((resolve,reject)=>{
				this.axios({
					method: "post",
					url: "/api/check/check_items_handle/",
					data:{ //请求参数放在请求体
						uuid:uuid
					}
				}).then(res => {
					if (res.data.code == 200) {
						resolve(res.data);
					} else if(res.data.code == 500){
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					}
				});
			});
			return p;
		},

		//新一轮的审查-不必填
		//整篇审查
		wholeReviewFunNoRequired(){

		},
		//条目审查
		itemReviewFunnNoRequired(){

		}	
	}
};
</script>
<style lang="scss" scope>
@import "../../../../assets/css/dialog.scss";//弹窗样式
</style>